import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_MainBilling = _resolveComponent("MainBilling")!
  const _component_PriceList = _resolveComponent("PriceList")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
        "fixed-tabs": "",
        style: {"background-color":"white !important","border-radius":"16px","overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "clients",
            href: "#clients"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("strong", null, "Tous les clients", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "dashboard",
            href: "#dashboard"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("strong", null, "Tableau de bord", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "clientBilling",
            href: "#clientBilling"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("strong", null, "Un client", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "priceList",
            href: "#priceList"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("strong", null, "Grille tarifaire", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "clients" }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            size: 70,
                            width: 7,
                            color: "primary",
                            indeterminate: "",
                            style: {"margin":"24px"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "pt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "d-flex justify-end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            onClick: _withModifiers(_ctx.download, ["stop"]),
                            loading: _ctx.excelLoading,
                            disabled: !_ctx.clients.length,
                            size: "small",
                            icon: "$fa-cloud-download-alt"
                          }, null, 8, ["onClick", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.headers,
                            items: _ctx.clients,
                            loading: _ctx.loading,
                            class: "table",
                            "fixed-header": "",
                            "max-height": "60vh"
                          }, {
                            item: _withCtx((props) => [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.name), 1),
                                _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.formatDate(props.item.createdAt)), 1),
                                _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.bobbeePriceList
                                                ? props.item.bobbeePriceList.name
                                                : ""), 1),
                                _createElementVNode("td", _hoisted_4, _toDisplayString(props.item.lastCount), 1),
                                _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.lastPrice, undefined)), 1),
                                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.totalPrice,
                                                undefined,
                                            )), 1),
                                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.totalInvoicedPrice,
                                                undefined,
                                            )), 1),
                                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatPercentage(props.item.variation)), 1),
                                _createElementVNode("td", _hoisted_9, [
                                  (props.item.id === 'all' || !props.item.grouped)
                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.createInvoices(props.item)), ["stop"]),
                                        loading: props.item.invoiceLoading,
                                        size: "small",
                                        icon: "$fa-file-invoice"
                                      }, null, 8, ["onClick", "loading"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "dashboard" }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            size: 70,
                            width: 7,
                            color: "primary",
                            indeterminate: "",
                            style: {"margin":"24px"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "pt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            outlined: "",
                            block: "",
                            modelValue: _ctx.displayType,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.displayType) = $event)),
                            items: _ctx.displayTypes,
                            "item-value": "id",
                            label: "Affichage",
                            density: "compact",
                            "item-title": (item) => item.name
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "1" }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            outlined: "",
                            block: "",
                            modelValue: _ctx.accountingFirmId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountingFirmId) = $event)),
                            items: _ctx.clients,
                            "item-value": "id",
                            label: "Cabinets",
                            density: "compact",
                            "item-title": (item) => item.name
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                            "hide-details": true,
                            label: "Date de début",
                            mandatory: false,
                            textFieldReadOnly: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker, {
                            modelValue: _ctx.endDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                            "hide-details": true,
                            label: "Date de fin",
                            mandatory: false,
                            textFieldReadOnly: false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "2",
                        class: "d-flex justify-end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            text: "",
                            color: "primary",
                            onClick: _withModifiers(_ctx.download, ["stop"]),
                            loading: _ctx.excelLoading,
                            disabled: !_ctx.clients.length,
                            size: "small",
                            icon: "$fa-cloud-download-alt"
                          }, null, 8, ["onClick", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.chartData)
                        ? (_openBlock(), _createBlock(_component_bar_chart, {
                            key: 0,
                            data: _ctx.chartData,
                            options: _ctx.options,
                            height: _ctx.$vuetify.display.mobile ? 200 : 350
                          }, null, 8, ["data", "options", "height"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "clientBilling" }, {
            default: _withCtx(() => [
              _createVNode(_component_MainBilling, { clients: _ctx.clients }, null, 8, ["clients"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "priceList" }, {
            default: _withCtx(() => [
              _createVNode(_component_PriceList)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}